import Button, { ButtonProps } from "react-bootstrap/esm/Button";
import { useNavigate } from "react-router-dom";
import { Icon, fas } from "..";

export const BackButton = (props: ButtonProps) => {
    const navigate = useNavigate();
    return (
        <Button {...props} onClick={props.onClick ? ((e) => props.onClick?.(e)) : (() => navigate(-1))} variant={props.variant ?? "secondary"} className="mb-2">
            <Icon icon={fas.faAngleLeft} /> Back
        </Button>
    );
}
